<script lang="ts">
      import { onMount, untrack } from 'svelte'
      import { getAnalyticsContext } from './ts/Anatytics.svelte'

      let { id = 'G-3QN4HRDZ8B' } = $props()

      function gtagConsentUpdate(consent: any) {
            gtag('consent', 'update', { ...consent })
      }

      function defaultConsent(): { [keyof: string]: 'denied' | 'granted' | undefined } {
            return {
                  ad_storage: 'denied',
                  ad_user_data: 'denied',
                  ad_personalization: 'denied',
                  analytics_storage: 'denied',
            }
      }

      onMount(() => {
            if (typeof gtag == 'undefined') return
            gtag('js', new Date())
            gtag('config', id)
            gtag('consent', 'default', defaultConsent())
      })

      const analytics = getAnalyticsContext()

      $effect(() => {
            analytics.consent
            untrack(() => {
                  //console.log('gtag consent update', analytics.consent)
                  if (analytics.consent.gtag) gtagConsentUpdate(analytics.consent.gtag)
            })
      })
</script>

<svelte:head>
      {#if id != ''}
            <script async src="https://www.googletagmanager.com/gtag/js?id={id}"></script>
            <script>
                  window.dataLayer = window.dataLayer || []
                  function gtag() {
                        dataLayer.push(arguments)
                  }
            </script>
      {/if}
</svelte:head>

<style lang="postcss">
</style>
